'use client';
import { useCurrentUser } from '@/hooks/useStore';
import { useToggle } from '@/hooks/useToggle';
import { isAdmin } from '@/utils/users';
import { PAGES } from '@/constants/pages';
import Divider from '@/components/Divider';
import {
  AdminIcon,
  CompanyIcon,
  HomeIcon,
  InvestorIcon,
  NewsIcon,
} from '@/icons';
import SidebarButton from './SidebarButton';
import { classes, styles } from './utils';

export { SIDEBAR_EXPANDED_WIDTH, SIDEBAR_WIDTH } from './constants';

export default function AppSidebar() {
  const currentUser = useCurrentUser();
  const [isExpanded, toggleExpanded] = useToggle(false);

  return (
    <nav
      className={classes.sidebar}
      style={styles.sidebar(isExpanded)}
      onMouseEnter={() => toggleExpanded(true)}
      onMouseLeave={() => toggleExpanded(false)}>
      <SidebarButton
        href={PAGES.HOME}
        label="Home"
        renderIcon={(className) => <HomeIcon size={18} className={className} />}
      />
      <SidebarButton
        href={PAGES.NEWS}
        label="News"
        renderIcon={(className) => <NewsIcon size={18} className={className} />}
      />
      <SidebarButton
        href={PAGES.COMPANIES}
        label="My Companies"
        renderIcon={(className) => (
          <CompanyIcon size={18} className={className} />
        )}
      />
      {isAdmin(currentUser) && (
        <>
          <Divider className={classes.divider} />
          <SidebarButton
            href={PAGES.INVESTORS}
            label="Investors"
            renderIcon={(className) => (
              <InvestorIcon size={18} className={className} />
            )}
          />
          <SidebarButton
            href={PAGES.ADMIN}
            label="Admin"
            renderIcon={(className) => (
              <AdminIcon size={18} className={className} />
            )}
          />
        </>
      )}
    </nav>
  );
}
